import ReactTooltip from "react-tooltip";

function Tooltip() {
  return (
    <ReactTooltip
      className="tooltip"
      multiline={true}
      effect="solid"
      textColor="#ffffff"
      backgroundColor="#2E2E2E"
      place="bottom"
      delayHide={1000}
      offset={{ top: -5, left: 0 }}
    />
  );
}

export default Tooltip;
